<template>
  <div class="twoLangWrapper">
    <label
      v-if="label"
      class="label"
    >
      <span>
        {{ label }}
        <b v-if="optional">*optional</b>
      </span>

      <span
        v-if="validation.$error"
        class="error"
      >Value is required</span>
    </label>

    <div
      v-if="!multiline"
      :class="{ inline: inline }"
    >
      <md-field class="field">
        <label>EN</label>
        <md-input
          :value="newValue.en"
          @input="emitUpdate($event, 'en')"
        />
      </md-field>

      <md-field class="field">
        <label>UK</label>
        <md-input
          :value="newValue.uk"
          @input="emitUpdate($event, 'uk')"
        />
      </md-field>
    </div>

    <div v-else>
      <md-field>
        <label>EN</label>
        <md-textarea
          :value="newValue.en"
          md-autogrow
          @input="emitUpdate($event, 'en')"
        />
      </md-field>

      <md-field>
        <label>UK</label>
        <md-textarea
          :value="newValue.uk"
          md-autogrow
          @input="emitUpdate($event, 'uk')"
        />
      </md-field>
    </div>
  </div>
</template>
<script>
export default {
  name: "TwoLanguageInput",
  props: {
    label: { type: String, default: "" },
    value: {
      type: Object,
      required: true,
      en: { type: String, default: "" },
      uk: { type: String, default: "" }
    },
    inline: { type: Boolean },
    multiline: { type: Boolean },
    optional: { type: Boolean },
    validation: {
      type: Object,
      default: () => ({ $error: false }),
      $error: { type: Boolean }
    }
  },
  data() {
    return {
      newValue: this.$props.value
    };
  },
  methods: {
    emitUpdate(value, key) {
      this.newValue[key] = value;
      this.$emit("update:value", this.newValue);
    }
  }
};
</script>
<style scoped lang="scss">
  .label {
    display: flex;
    justify-content: space-between;
  }

  .twoLangWrapper {
    max-width: 750px;
  }

  .wrapper label b {
    font-weight: 500;
  }

  .inline {
    display: flex;
    column-gap: 12px;
  }

  .error {
    color: red;
    font-weight: 500;
  }
</style>
